import { useSelector } from 'react-redux'
import LogoCopia from '../../assets/img/logo-copia.svg'
import { ThemeProvider } from '@emotion/react'
import { HeaderComponentProps } from '@consorciaoc-prj/eacat30_components/dist/components/Header/Header.types'
import { Header, StylesProvider } from '@consorciaoc-prj/eacat30_components'
import { AppBar } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { performLogout } from 'api/queries'
import { toggleSidebar } from 'store/actions/SidebarAction'
import { useAppDispatch } from 'hooks'

export default function HeaderAdapter() {
  const ensInfo = useSelector((state: any) => state.ens)
  const dispatch = useAppDispatch()

  const { mutate } = useMutation({
    mutationFn: performLogout,
    mutationKey: ['idpLogout'],
    onSuccess: () => {
      window.location.reload()
    },
    retry: false,
    useErrorBoundary: true
  })

  const userData: HeaderComponentProps['userData'] = {
    ensActiu: {
      codiEns: ensInfo.ensActiu,
      nom: ensInfo.nomEnsActiu
    },
    nomComplet: ensInfo.nomIdp,
    ensList: ensInfo?.ensDisponibles?.map((ens: any) => ({
      codiEns: ens?.ens,
      nom: ens?.nom
    }))
  }

  const handlers: HeaderComponentProps['handlers'] = {
    menu: () => {
      dispatch(toggleSidebar())
    },
    ensListItem: (ev?: any) => {
      window.location.href = `/copia?ensActiu=${ev}`
    },
    help: () => window.open('https://suport.aoc.cat/'),
    logout: () => mutate()
  }

  const labels: HeaderComponentProps['labels'] = {
    ensListLabel: 'Ens disponibles',
    logoutLabel: 'Tancar sessió'
  }

  const urlEacat = () => {
    if (!ensInfo || !ensInfo.ensActiu || !ensInfo.urlEacat) {
      return undefined
    }
    const url = new URL(ensInfo.urlEacat)
    url.pathname = '/webst/redirect'
    url.searchParams.append('module', 'public-home')
    url.searchParams.append('ine10', ensInfo.ensActiu)
    return url.toString()
  }

  return (
    <StylesProvider provider={ThemeProvider}>
      <AppBar sx={{ boxShadow: 'none' }} position="sticky">
        <Header
          userData={userData}
          handlers={handlers}
          appLogo={{ img: LogoCopia, href: `/copia` }}
          labels={labels}
          logoEacatURL={urlEacat()}
          popoverProps={{ disableScrollLock: true }}
          isImpersonated={ensInfo.impersonated ?? false}
        />
      </AppBar>
    </StylesProvider>
  )
}
